export default __webpack_public_path__ + "static/media/editAccount.146b3413.svg";